





































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import DateUtils from '@/common/js/DateUtils'
import moment from 'moment'


class PageFlowRequest extends PageRequest {
    beginSignForTime?: Date;
    endSignForTime?: Date;
    shipment: string;
}

@Component({
    name: "signlogisticsList",
})
export default class SignLogistics extends AbpBase {
    pagerequest: PageFlowRequest = new PageFlowRequest();
    signForTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
    get list() {
        return this.$store.state.backSignlogistics.list;
    };
    get loading() {
        return this.$store.state.backSignlogistics.loading;
    };
    pageChange(page: number) {
        this.$store.commit('backSignlogistics/setCurrentPage', page);
        this.getpage();
    };
    pagesizeChange(pagesize: number) {
        this.$store.commit('backSignlogistics/setPageSize', pagesize);
        this.getpage();
    };

    async exportExcel() {
        await this.$store.dispatch({
            type: 'backSignlogistics/exportExcel',
            data: { beginSignForTime: this.pagerequest.beginSignForTime, endSignForTime: this.pagerequest.endSignForTime, Shipment: this.pagerequest.shipment }
        })
    }

    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        if (this.signForTime.length > 0) {
            this.pagerequest.beginSignForTime = this.signForTime[0];
        }
        if (this.signForTime.length > 1) {
            this.pagerequest.endSignForTime = this.signForTime[1];
        }

        await this.$store.dispatch({
            type: 'backSignlogistics/getAll',
            data: this.pagerequest
        })
    }
    async searchPage() {
        this.$store.state.backSignlogistics.currentPage = 1;
        this.getpage();
    }
    get pageSize() {
        return this.$store.state.backSignlogistics.pageSize;
    }
    get totalCount() {
        return this.$store.state.backSignlogistics.totalCount;
    }
    get currentPage() {
        return this.$store.state.backSignlogistics.currentPage;
    }
    columns = [{
        title: '快递单号',
        key: 'shipment',
        width: 200,
    }, {
            title: '签收时间',
            key: 'signForTime',
            width: 200,
            render: (h: any, params: any) => {
                return h('span', params.row.signForTime ? DateUtils.formatLongDate(new Date(params.row.signForTime)) : '');
            }
        }, {
            title: '状态',
            width: 100,
            key: 'receiveStatusText',
            //render: (h: any, params: any) => {
            //    return h('span', Enums.ShipmentReceiveStatus.filter(function (item) { return item.value == params.row.receiveStatus })[0].name);
            //}
        }, 
    ]
    async created() {
        this.getpage();
    }
}
